<div class="card pb-4">
    <p-card>
        <ng-template pTemplate="header">
            <div class="flex flex-row flex-row-reverse p-1 pr-6">
                <p-button *ngIf="activeSubmission" icon="pi pi-file-import" [rounded]="true" [text]="true" [raised]="true" (onClick)="fillFromSubmission()"></p-button>
                <p-button icon="pi pi-eraser" [rounded]="true" [text]="true" [raised]="true" (onClick)="clearForm()" class="mr-2 ml-2"></p-button>
            </div>
        </ng-template>
        <div *ngIf="!claim.carrier" class="grid formgrid p-fluid">
            <div class="field mb-4 col-2">
                <div>
                    <p-button *ngIf="activeSubmission" icon="pi pi-file-import" [raised]="true" [rounded]="true" [text]="true" (onClick)="carrierSearch.searchFor(activeSubmission.payerName) " ></p-button>
                </div>
            </div>
            <div class="field mb-4 col-8">
                <app-carrier-search #carrierSearch placeholder="Search for a Carrier" (carrierSelected)="carrierSelected($event)" ></app-carrier-search>
            </div>
            <div class="field mb-4 col-2">
                <div>
                    <p-button icon="pi pi-plus" [rounded]="true" [text]="true" [raised]="true" (onClick)="newCarrierOp.toggle($event)"></p-button>
                    <p-overlayPanel #newCarrierOp [style]="{width: '50vw', height:'50vh'}">
                        <app-carrier-editor (saved)="newCarrierOp.hide(); carrierCreated($event)" (cancelled)="newCarrierOp.hide()"></app-carrier-editor>
                    </p-overlayPanel>
                </div>
            </div>
        </div>
        <div *ngIf="claim.carrier" class="card mb-2 mt-2">
            <p-card header="Carrier">
                <div class="flex flex-auto">
                    <div class="flex flex-auto justify-content-start align-items-center">{{claim.carrier.name}}</div>
                    <div class="flex justify-content-end align-items-end">
                        <p-button icon="pi pi-pencil" class="mr-2" [rounded]="true" [text]="true" [raised]="true" (onClick)="editCarrierOp.toggle($event)"></p-button>
                        <p-overlayPanel #editCarrierOp [style]="{width: '50vw', height:'50vh'}">
                            <app-carrier-editor [carrier]="claim.carrier" (saved)="editCarrierOp.hide(); carrierEdited(claim.carrier.id,$event)" (cancelled)="editCarrierOp.hide()"  ></app-carrier-editor>
                        </p-overlayPanel>
                    </div>
                    <div class="flex justify-content-end align-items-center">
                        <p-button label="Unassign" [rounded]="true" [text]="true" [raised]="true" (onClick)="claim.carrier = undefined"></p-button>
                    </div>
                </div>
            </p-card>
        </div>
        <div *ngIf="!claim.adjuster" class="grid formgrid p-fluid ">
            <div class="field mb-4 col-2">
                <div>
                    <p-button *ngIf="activeSubmission" icon="pi pi-file-import" [raised]="true" [rounded]="true" [text]="true" (onClick)="adjusterSearch.searchFor(activeSubmission.adjusterFirstName + ' ' + activeSubmission.adjusterLastName) " ></p-button>
                </div>
            </div>
            <div class="field mb-4 col-8">
                <app-adjuster-search #adjusterSearch placeholder="Search for an Adjuster" (adjusterSelected)="adjusterSelected($event)" ></app-adjuster-search>
            </div>
            <div class="field mb-4 col-2">
                <div>
                    <p-button icon="pi pi-plus" [rounded]="true" [text]="true" [raised]="true" (onClick)="newAdjusterOp.toggle($event)"></p-button>
                    <p-overlayPanel #newAdjusterOp [style]="{width: '50vw', height:'50vh'}">
                        <app-adjuster-editor (saved)="newAdjusterOp.hide(); adjusterCreated($event)" (cancelled)="newAdjusterOp.hide()"></app-adjuster-editor>
                    </p-overlayPanel>
                </div>
            </div>
        </div>
        <div *ngIf="claim.adjuster" class="card mb-2 mt-2">
            <p-card header="Adjuster">
                <div class="flex flex-auto">
                    <div class="flex flex-auto justify-content-start align-items-center">{{claim.adjuster.firstName}} {{claim.adjuster.lastName}}</div>
                <div class="flex flex-column w-full mt-2">
                    <p-checkbox [binary]="true" [ngModel]="isAdjusterNotified(claim.adjuster)" (onChange)="setAdjusterNotification(claim.adjuster,$event.checked)" label="Notify Adjuster"></p-checkbox>
                </div>
                    <div class="flex justify-content-end align-items-end">
                        <p-button icon="pi pi-pencil" class="mr-2" [rounded]="true" [text]="true" [raised]="true" (onClick)="editAdjusterOp.toggle($event)"></p-button>
                        <p-overlayPanel #editAdjusterOp [style]="{width: '50vw', height:'50vh'}">
                            <app-adjuster-editor [adjuster]="claim.adjuster" (saved)="editAdjusterOp.hide(); adjusterEdited(claim.adjuster.id,$event)" (cancelled)="editAdjusterOp.hide()"  ></app-adjuster-editor>
                        </p-overlayPanel>
                    </div>
                    <div class="flex justify-content-end align-items-center">
                        <p-button label="Unassign" [rounded]="true" [text]="true" [raised]="true" (onClick)="unassignAdjuster('adjuster')"></p-button>
                    </div>
                </div>
            </p-card>
        </div>
        <div *ngIf="claim.adjuster && !claim.adjuster2" class="flex grid formgrid p-fluid mt-2">
            <p-button *ngIf="!showAdjuster2Search" label="Second Adjuster" [raised]="true" icon="pi pi-plus" (onClick)="showAdjuster2Search = true"></p-button>
            <div *ngIf="showAdjuster2Search" class="field mb-4 col-8">
                <app-adjuster-search placeholder="Search for an Adjuster" (adjusterSelected)="adjuster2Selected($event)" ></app-adjuster-search>
            </div>
            <div class="field mb-4 col-2">
                <div>
                    <p-button *ngIf="showAdjuster2Search" [raised]="true" icon="pi pi-plus" (onClick)="newAdjuster2Op.toggle($event)"></p-button>
                    <p-button *ngIf="showAdjuster2Search" [raised]="true" icon="pi pi-trash" (onClick)="showAdjuster2Search = false"></p-button>
                    <p-overlayPanel #newAdjuster2Op [style]="{width: '50vw', height:'50vh'}">
                        <app-adjuster-editor (saved)="newAdjuster2Op.hide(); adjuster2Created($event)" (cancelled)="newAdjuster2Op.hide()"></app-adjuster-editor>
                    </p-overlayPanel>
                </div>
            </div>
        </div>
        <div *ngIf="claim.adjuster && claim.adjuster2" class="card mb-2 mt-2">
            <p-card header="Adjuster 2">
                <div class="flex flex-auto">
                    <div class="flex flex-auto justify-content-start align-items-center">{{claim.adjuster2.firstName}} {{claim.adjuster2.lastName}}</div>
                <div class="flex flex-column w-full mt-2">
                    <p-checkbox [binary]="true" [ngModel]="isAdjusterNotified(claim.adjuster2)" (onChange)="setAdjusterNotification(claim.adjuster2,$event.checked)" label="Notify Adjuster 2"></p-checkbox>
                </div>
                    <div class="flex justify-content-end align-items-end">
                        <p-button icon="pi pi-pencil" class="mr-2" [rounded]="true" [text]="true" [raised]="true" (onClick)="editAdjuster2Op.toggle($event)"></p-button>
                        <p-overlayPanel #editAdjuster2Op [style]="{width: '50vw', height:'50vh'}">
                            <app-adjuster-editor [adjuster]="claim.adjuster2" (saved)="editAdjuster2Op.hide(); adjuster2Edited(claim.adjuster.id,$event)" (cancelled)="editAdjuster2Op.hide()"  ></app-adjuster-editor>
                        </p-overlayPanel>
                    </div>
                    <div class="flex justify-content-end align-items-center">
                        <p-button label="Unassign" [rounded]="true" [text]="true" [raised]="true" (onClick)="unassignAdjuster('adjuster2')"></p-button>
                    </div>
                </div>
            </p-card>
        </div>
        <div *ngIf="claim.adjuster && !claim.adjusterSupervisor" class="flex grid formgrid p-fluid mt-2 ">
            <p-button *ngIf="!showAdjusterSupervisorSearch" label="Adjuster Supervisor" [raised]="true" icon="pi pi-plus" (onClick)="showAdjusterSupervisorSearch=true"></p-button>
            <div *ngIf="showAdjusterSupervisorSearch" class="field mb-4 col-8">
                <app-adjuster-search placeholder="Search for an Adjuster" (adjusterSelected)="adjusterSupervisorSelected($event)" ></app-adjuster-search>
            </div>
            <div class="field mb-4 col-2">
                <p-button *ngIf="showAdjusterSupervisorSearch" [raised]="true" icon="pi pi-plus" (onClick)="newAdjusterSupervisorOp.toggle($event)"></p-button> 
                <p-button *ngIf="showAdjusterSupervisorSearch" [raised]="true" icon="pi pi-trash" (onClick)="showAdjusterSupervisorSearch = false"></p-button>
                <p-overlayPanel #newAdjusterSupervisorOp [style]="{width: '50vw', height:'50vh'}">
                    <app-adjuster-editor (saved)="newAdjusterSupervisorOp.hide(); adjusterSupervisorCreated($event)" (cancelled)="newAdjusterSupervisorOp.hide()"></app-adjuster-editor>
                </p-overlayPanel>
            </div>
        </div>
        <div *ngIf="claim.adjuster && claim.adjusterSupervisor" class="card mb-2 mt-2">
            <p-card header="Adjuster Supervisor">
                <div class="flex flex-auto">
                    <div class="flex flex-auto justify-content-start align-items-center">{{claim.adjusterSupervisor.firstName}} {{claim.adjusterSupervisor.lastName}}</div>
                <div class="flex flex-column w-full mt-2">
                    <p-checkbox [binary]="true" [ngModel]="isAdjusterNotified(claim.adjusterSupervisor)" (onChange)="setAdjusterNotification(claim.adjusterSupervisor,$event.checked)" label="Notify Adjuster Supervisor"></p-checkbox>
                </div>
                    <div class="flex justify-content-end align-items-end">
                        <p-button icon="pi pi-pencil" class="mr-2" [rounded]="true" [text]="true" [raised]="true" (onClick)="editAdjusterSupervisorOp.toggle($event)"></p-button>
                        <p-overlayPanel #editAdjusterSupervisorOp [style]="{width: '50vw', height:'50vh'}">
                            <app-adjuster-editor [adjuster]="claim.adjusterSupervisor" (saved)="editAdjusterSupervisorOp.hide(); adjusterSupervisorEdited(claim.adjuster.id,$event)" (cancelled)="editAdjusterSupervisorOp.hide()"  ></app-adjuster-editor>
                        </p-overlayPanel>
                    </div>
                    <div class="flex justify-content-end align-items-center">
                        <p-button label="Unassign" [rounded]="true" [text]="true" [raised]="true" (onClick)="unassignAdjuster('adjusterSupervisor')"></p-button>
                    </div>
                </div>
            </p-card>
        </div>
        <div class="grid formgrid p-fluid mt-2">
            <div class="field mb-4 col-4 mt-4">
                <span>
                    <p-floatLabel>
                        <input id="ClaimNumber" pInputText [(ngModel)]="claim.claimNumber" />
                        <label for="ClaimNumber">Claim Number</label>
                    </p-floatLabel>
                </span>
            </div>
            <div class="field mb-4 col-4 mt-4">
                <span>
                    <p-floatLabel>
                        <p-calendar appendTo="body" id="claimDate"  [(ngModel)]="claim.claimDate"></p-calendar>
                        <label for="claimDate">Claim Date</label>
                    </p-floatLabel>
                </span>
            </div>
            <div class="field mb-4 col-4 mt-4">
                <span>
                    <p-floatLabel>
                        <input id="bodyPart" pInputText [(ngModel)]="claim.bodyPart" />
                        <label for="bodyPart">Body Part</label>
                    </p-floatLabel>
                </span>
            </div>
            <div class="field mb-4 col-4 mt-4">
                <span>
                    <p-floatLabel>
                        <input id="caseManager" pInputText [(ngModel)]="claim.caseManager" />
                        <label for="caseManager">Case Manager</label>
                    </p-floatLabel>
                </span>
            </div>
            <div class="field mb-4 col-4 mt-4">
                <span>
                    <p-floatLabel>
                        <input id="contactInfo" pInputText [(ngModel)]="claim.contactInfo" />
                        <label for="contactInfo">Contact Info</label>
                    </p-floatLabel>
                </span>
            </div>
            <div class="field mb-4 col-12 ">
                <span>
                    <p-floatLabel>
                        <textarea id="accidentDescription" rows="5" cols="45" pInputTextarea [(ngModel)]="claim.accidentDescription"></textarea>
                        <label for="accidentDescription">Accident Description</label>
                    </p-floatLabel>
                </span>
            </div>            
            <div class="field mb-4 col-12 ">
                <span>
                    <p-floatLabel>
                        <textarea id="injuryDescription" rows="5" cols="45" pInputTextarea [(ngModel)]="claim.injuryDescription"></textarea>
                        <label for="injuryDescription">Injury Description</label>
                    </p-floatLabel>
                </span>
            </div>
        </div>
        <div class="flex mt-2 col-12 justify-content-center ">
            <p-buttonGroup>
                <p-button label="Save" icon="pi pi-check" (onClick)="saveButtonPressed($event)" [disabled]="!allowSave()"></p-button>
                <p-button label="Cancel" icon="pi pi-times" severity="danger" (onClick)="cancelButtonPressed($event)"></p-button>
            </p-buttonGroup>
        </div>
  
    </p-card>
</div>
